import React from "react";
import { Box } from "@mui/material";
import DashboardPage from "../components/dashboard/DashboardPage";

/**
 * Fills the app main column (flex parent in App.js) so dashboard background / min-height behave consistently.
 */
export default function DashboardView() {
  return (
    <Box
      sx={{
        flex: 1,
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minHeight: 0,
      }}
    >
      <DashboardPage />
    </Box>
  );
}
